/* @flow */

import type { ReadOnlyKeyValuePair } from '../jsHelpers/types';

export const SEARCH: ReadOnlyKeyValuePair<number> = Object.freeze({
  HistoryMaxCount: 10,
  StringMinLength: 3,
});
